import { Box, Container, Paper } from '@mui/material';

interface LayoutProps {
  children: React.ReactNode;
}

export const AppLayout = ({ children }: LayoutProps) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
        py: 4,
      }}
    >
      <Container maxWidth="xl">{children}</Container>
    </Box>
  );
};

export const DashboardSection = ({
  children,
  elevation = 1,
}: {
  children: React.ReactNode;
  elevation?: number;
}) => {
  return (
    <Paper
      elevation={elevation}
      sx={{
        p: 4,
        mb: 3,
        // borderRadius: 2,
        background: '#ffffff',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-2px)',
        },
      }}
    >
      {children}
    </Paper>
  );
};

export const DashboardGrid = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
        },
        gap: 3,
        width: '100%',
      }}
    >
      {children}
    </Box>
  );
};

export const DashboardGridItem = ({
  children,
  lg = 4,
}: {
  children: React.ReactNode;
  xs?: number;
  md?: number;
  lg?: number;
}) => {
  // For full width items (like charts)
  const isFullWidth = lg === 12;

  return (
    <Box
      sx={{
        gridColumn: isFullWidth ? '1 / -1' : 'span 1',
      }}
    >
      {children}
    </Box>
  );
};
